import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { ReviewVideosPage } from './review-videos';

const WrappedPage = withAuth(ReviewVideosPage);
const WrappedAccountView = withLayout(LayoutType.WithOldNavOnly, WrappedPage);

export { WrappedAccountView as ReviewVideosPage };
